import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export interface PostActionsDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEdit: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
}

export function PostActionsDrawer({
  open,
  onOpenChange,
  onEdit,
  onDelete,
  isDeleting = false,
}: PostActionsDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <div className="w-full">
          <DrawerHeader>
            <DrawerTitle>Post Actions</DrawerTitle>
            <DrawerDescription className="sr-only">
              Actions for this post.
            </DrawerDescription>
          </DrawerHeader>
          <div className="flex flex-col gap-2 pb-6">
            <PostActionButton
              label="Edit"
              className="bg-slate-600"
              icon={<PencilSimpleIcon size={24} weight="regular" />}
              onClick={onEdit}
            />
            <PostActionButton
              label="Delete"
              className="border border-red-400 text-red-400"
              icon={
                <TrashIcon
                  size={24}
                  weight="regular"
                  className="text-red-400"
                />
              }
              onClick={onDelete}
              disabled={isDeleting}
            />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}

interface PostActionButtonProps {
  label: string;
  className: string;
  icon: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

function PostActionButton({
  label,
  className,
  icon,
  onClick,
  disabled,
}: PostActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex flex-row w-full items-center gap-2 rounded-md px-5 py-4 ${className} ${
        disabled ? 'cursor-not-allowed' : ''
      }`}
    >
      <span className="flex items-center text-slate-50">{icon}</span>
      <span className="text-large">{label}</span>
    </button>
  );
}


